var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditiconsettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.74999L11.25 5.62499M8.125 12.5H13.125M3.125 9.99999L2.5 12.5L5 11.875L12.2413 4.63374C12.4756 4.39933 12.6072 4.08145 12.6072 3.74999C12.6072 3.41854 12.4756 3.10065 12.2413 2.86624L12.1337 2.75874C11.8993 2.52441 11.5815 2.39276 11.25 2.39276C10.9185 2.39276 10.6007 2.52441 10.3663 2.75874L3.125 9.99999Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditiconsettings);
export default __webpack_public_path__ + "static/media/editiconsettings.8b3046d52684c6116ad341b67497ebf0.svg";
export { ForwardRef as ReactComponent };